/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
// import Image from 'next/image'
import React from 'react'
// import { BadgeHeader } from '../BadgeHeader'
import { BaseCard } from '../BaseCard'
// import { CardFooter } from '../CardFooter'
// import { DiscountHeader } from '../DiscountHeader'
import { MyStatsCardProps } from '../index'
import moment from 'moment'
// import { Overlay } from '../Overlay'
// import { ProgressSection } from '../ProgressSection'

// import { toBase64, shimmer } from 'src/common/utils'
const superLightStatColors = {
    1: '#E4DFFF',
    2: '#E4DFFF',
    3: '#FFD4C9',
    4: '#D6FFD6',
    5: '#E4F4FF',
    6: '#FFD4C9',
    7: '#D6FFD6'
}

const statColors = {
    1: '#8C81F8',
    2: '#8C81F8',
    3: '#FF7C6D',
    4: '#49b848',
    5: '#1E87FF',
    6: '#FF7C6D',
    7: '#49b848'
}

const statIcons = {
    1: 'pin',
    2: 'walk',
    3: 'calories',
    4: 'heartrate',
    5: 'scale',
    6: 'stopwatch',
    7: 'yf-race'
}

const formatPeriodSubLabel = (period, date): string => {
    if (period === 1) {
        // Week
        return `Since ${moment(date).format('MM/DD') as string}`
    } else if (period === 2) {
        // Month
        return moment(date).format('MMMM') as string
    } else if (period === 3) {
        // Year
        return `Since ${moment(date).format('M/D/YYYY') as string}`
    } else if (period === 4) {
        // All Time
        return `Since ${moment(date).format('M/D') as string}`
    }
}

const formatDescription = (item, condensed) => {
    const color = statColors[item.type]
    const fontSize = '16px'
    const lineHeight = '20px'
    const formattedDescription = item.periods[0].description.replace(
        /'([^']+)'/g,
        `<span style="font-size:${fontSize};line-height:${lineHeight};color:${color};">$1</span>`
    )
    const formattedProgressDescription: string =
        item.periods[0].progressDescription.replace(
            /'([^']+)'/g,
            `<span variant="bold" fontSize={${fontSize}} lineHeight={${lineHeight}} color="${color}">$1</span>`
        )
    return `<div variant="medium" fontSize={${fontSize}} lineHeight={${lineHeight}} numberOfLines={4}>${formattedDescription}${
        condensed ? ` (${formattedProgressDescription})` : ''
    }</div>`
}

const renderPeriods = (item): any => {
    return item.periods.map((p, idx): any => {
        return (
            <div className="flex bg-white rounded-xl mt-4 pl-2 py-2" key={idx}>
                <div
                    className="flex items-center justify-center flex-col w-12 h-12 flex-shrink-0 rounded-xl text-white"
                    style={{ backgroundColor: statColors[item.type] }}
                >
                    {p.period !== 3 && (
                        <>
                            <p className="text-xs">
                                {moment(p.date).format('MMM').toUpperCase()}
                            </p>
                            <p className="text-xs">{moment(p.date).format('DD')}</p>
                        </>
                    )}

                    {p.period === 3 && (
                        <>
                            <p className="text-xs">YEAR</p>
                            <p className="text-xs">{moment(p.date).format('YYYY')}</p>
                        </>
                    )}
                </div>
                <div className="flex items-center justify-around w-full px-4">
                    <div className="mr-auto">
                        <p className="text-sm">{p.label}</p>
                        <p className="text-xs">
                            {formatPeriodSubLabel(p.period, p.date)}
                        </p>
                    </div>
                    <p
                        style={{
                            color: statColors[item.type]
                        }}
                    >{`${p.formattedValue} ${p.shortUnit}`}</p>
                </div>
            </div>
        )
    })
}

export const MyStatsCard = ({
    // title,
    // subtitle,
    // badgeType = 'none',
    // progress,
    // distance = '',
    // percentOff = 0,
    // premiumText,
    // href = '/',
    // element = null,
    cardType,
    item,
    condensed = false
}: MyStatsCardProps) => {
    return (
        <BaseCard href={null} cardType={cardType} boxShadow={false}>
            <div
                style={{ backgroundColor: superLightStatColors[item.type], padding: 15 }}
            >
                <div>
                    {condensed ? (
                        <div className="flex justify-between">
                            <i
                                aria-hidden
                                style={{ color: statColors[item.type] }}
                                className={`fak fa-${statIcons[item.type]} text-3xl`}
                            ></i>
                            <img width="30px" height="30px" src="/logo.svg" />
                        </div>
                    ) : (
                        <div className="flex justify-between">
                            <i
                                aria-hidden
                                style={{ color: statColors[item.type] }}
                                className={`fak fa-${statIcons[item.type]} text-4xl`}
                            ></i>
                            <img width="30px" height="30px" src="/logo.svg" />
                        </div>
                    )}
                </div>
                <div
                    className="mt-6 font-medium"
                    dangerouslySetInnerHTML={{
                        __html: formatDescription(item, condensed)
                    }}
                />

                {!condensed && (
                    <div className="mt-6">
                        <div>{renderPeriods(item)}</div>
                    </div>
                )}
            </div>
        </BaseCard>
    )
}
